import 'lazysizes';
import { onSrcLoad } from "@libs/helpers";

document.addEventListener('lazybeforeunveil', function (e) {

	const bg = e.target.getAttribute('data-bg');
	const vid = e.target.getAttribute('data-video');
	const svgImage = e.target.getAttribute('data-href');

	// <div data-bg="etc"> turned into background-image
	if (bg) {
		e.target.style.backgroundImage = `url(${bg})`;
		e.target.classList.add('bg-loading');

		// reveal when the image has loaded:
		onSrcLoad(bg, function () {
			e.target.classList.remove('bg-loading');
		});
	}

	if ( vid ) {
		
		const v = document.createElement('video');
		const s = document.createElement('source');
		s.src = vid;
		v.setAttribute('autoplay','true');
		v.setAttribute('loop','true');
		v.setAttribute('muted','true');
		v.setAttribute('playsinline','true');
		v.appendChild( s );
		e.target.appendChild( v );
	}

	// Update <image> tags in SVGS:
	if (svgImage) {
		e.target.classList.add('bg-loading');
		onSrcLoad(svgImage, function () {
			e.target.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', svgImage);
			e.target.classList.remove('bg-loading');
		});
	}
});
